export default __webpack_public_path__ + "static/media/logo-white.4870fa9e.svg";